module.exports = __webpack_public_path__ + "static/img/sy_sj_ct.27cc3bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/sy_sj_ct.png
// module id = TA+Q
// module chunks = 1